import {textareaWithVariables_serializeDOMToValue} from '../dom/serialize'


// Copy the current selection (if any) onto `e.clipboardData` as plain
// text. The serialiser turns each pill back into its `data-token`
// (the literal `{TOKEN}` string) so paste into any other app reads
// correctly.
//
// Returns true if anything was written — callers use this to decide
// whether to `preventDefault()` and skip the browser default. (Browser
// default would put HTML — including pill `<span>` markup — onto the
// clipboard, which is exactly what we don't want.)
export function textareaWithVariables_copySelectionToClipboard(
    e: ClipboardEvent | React.ClipboardEvent,
): boolean {
    const sel = window.getSelection()
    if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return false
    const range = sel.getRangeAt(0)

    // Clone the selected fragment into an off-screen container so we
    // can run the serialiser against it without disturbing the editor.
    const container = document.createElement('div')
    container.appendChild(range.cloneContents())

    const text = textareaWithVariables_serializeDOMToValue(container)
    if (!text) return false

    e.clipboardData!.setData('text/plain', text)
    return true
}
